import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  listSalesViewers,
  inviteOrGrantSalesViewer,
  revokeSalesViewers,
  type SalesViewer,
  type InviteOrGrantInput,
  type InviteOrGrantResult,
  type RevokeSalesViewersResult,
} from '../services/api/externalSalesViewers';

const SALES_VIEWERS_QUERY_KEY = ['sales-viewers'] as const;

/**
 * Sales-viewer grant COLLECTION hooks (Phase 105, Plan 105-07). Mirrors
 * `useProjectExternalMembers.ts` / `useInviteExternalToProject.ts` with the
 * project dimension removed.
 */
export function useSalesViewers(enabled = true) {
  return useQuery<SalesViewer[], Error>({
    queryKey: SALES_VIEWERS_QUERY_KEY,
    queryFn: () => listSalesViewers(),
    enabled,
    staleTime: 10_000,
  });
}

export function useInviteOrGrantSalesViewer() {
  const queryClient = useQueryClient();
  return useMutation<InviteOrGrantResult, Error, InviteOrGrantInput>({
    mutationFn: (input) => inviteOrGrantSalesViewer(input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: SALES_VIEWERS_QUERY_KEY });
    },
  });
}

export function useRevokeSalesViewers() {
  const queryClient = useQueryClient();
  return useMutation<RevokeSalesViewersResult, Error, number[]>({
    mutationFn: (externalUserIds) => revokeSalesViewers(externalUserIds),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: SALES_VIEWERS_QUERY_KEY });
    },
  });
}
